<template>
    <div>
        <!-- <div @click="Delivercont">跳转</div> -->
        <Treem :treedata="data"></Treem>
    </div>
</template>

<script>
import Treem from '@/components/tree.vue'
export default {

    components:{
        Treem
    },

    data(){
        return{
            ss:null,
            UserInfo:JSON.parse(window.localStorage.getItem("getTokendata")),
            data: {},
            checked:false,
            checdata:"",
            name:'arrow',
            show:false
        }
    },
    mounted(){
        this.getDemp()
    },
    methods:{
        cheackDom(index){
            console.log(index)
            console.log(this.$refs.st.name)

            if(this.$refs.trs.name == index){
                 this.checked = !this.checked
            }
           
        },
        openList(){
            if(!this.show){
                this.name= 'arrow'
            }else{
                this.name = 'arrow-down'
            }
        },
        // 子组件传过来的部门id
        Delivercont(){
            this.$router.push({
                path: '/selfreg',
                query: {
                    dept_id: '99',
                }
            })
        },
        // 获取部门id
        getDemp(){
            let data ={
                method:'co.wx.dept.list',
                user_id:this.UserInfo.user_id,
                agent_id:this.UserInfo.agent_id
            }
            this.$serve(data).then(res=>{
                this.data=this.getFirstObj(res.data.data)
                console.log(this.data)
            })
        },

        getFirstObj(obj){
            for(var key in obj){
                return obj[key];
            }
        },
    }
}
</script>